import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { MinProfitControl } from "@/features/arbitrages/MinProfitControl";
import { NotificationsCard } from "@/features/opportunities/NotificationsCard";
import { ThresholdsCard } from "@/features/opportunities/ThresholdsCard";
import { readDefaultMinProfitAda, saveDefaultMinProfitAda } from "@/lib/settings/min-profit";

export const Route = createFileRoute("/settings")({ component: Settings });

function Settings() {
    const [minProfitAda, setMinProfitAda] = useState(readDefaultMinProfitAda);

    return (
        <div className="space-y-3 md:space-y-4">
            <Card>
                <CardHeader>
                    <h2 className="text-base font-semibold">Arbitrages</h2>
                </CardHeader>
                <CardContent className="space-y-2">
                    <MinProfitControl
                        id="default-min-profit-ada"
                        value={minProfitAda}
                        onChange={(ada) => {
                            saveDefaultMinProfitAda(ada);
                            setMinProfitAda(ada);
                        }}
                    />
                    <p className="text-sm text-muted-foreground">
                        The minimum profit the Arbitrages page opens with. Saved in this browser only; the bot records
                        every opportunity regardless.
                    </p>
                </CardContent>
            </Card>
            <ThresholdsCard />
            <NotificationsCard />
        </div>
    );
}
